import { render } from "./client-move-terminal-modal.vue?vue&type=template&id=3a69f952&scoped=true&ts=true"
import script from "./client-move-terminal-modal.vue?vue&type=script&lang=ts"
export * from "./client-move-terminal-modal.vue?vue&type=script&lang=ts"

import "./client-move-terminal-modal.vue?vue&type=style&index=0&id=3a69f952&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a69f952"]])

export default __exports__